import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
   videoDialog: {
      '& .MuiDialog-paper': {
      background: '#000',
      }
   },
   iframeWrapper: {
      '& video': {
      width: '100%',
      }
   },
}));

export default useStyles;